<template>
  <div style="text-align: center">
    <h3 class="kaihu">账号开户</h3>
    <step :active="3"></step>
    <img src="@/assets/kaihuchenggong.png" />
    <br />
    <b>恭喜您！开户成功</b>
    <div style="color:#B4CFFF;margin-top:48px;">
      您已完成开户信息输入，请您耐心等待平台人工审核。
      <br />
      审核通过后，平台将提交您的信息至银行进行电子账户开户审核。
    </div>
    <el-button>前往结算中心</el-button>
  </div>
</template>
<script>
import step from './step.vue';
export default {
  data() {
    return {};
  },
  components: {
    step
  }
};
</script>
<style lang="scss" scoped></style>
